
import ExternalConfiguration from '../../external-configuration';

import { add_to_local_storage_counter } from '../../helpers/utils';

const LogFileString = 'controllers::Analytics::Custom';

const Constants = {
  Events: {
    load: 'load',
    play: 'play',
    pause: 'pause',
    time: 'time',
    error: 'error',
    buffering: 'buffering',
    close: 'close',
  },
};

const Globals = {
  sendOnTime25_100: false,
  sendOnTime50_100: false,
  sendOnTime75_100: false,
  sendOnTime100_100: false,

  session: crypto.randomUUID(),
  distribution_host: window.location.hostname,
  played_seconds: 0,
  protocol: 'hls',      // TODO tener en cuenta si se esta reproduciendo de m3u8 / progresive / dash, etc...

  events_queue: [],
  last_send_timeout: null,

  playing: false,
  last_time_event: null,
  last_time_event_sent: null,
};

const CustomAnalytics = {

  send_events_inmediate: async () => {
    const LogFunctionString = `${LogFileString}::send_events_inmediate`;
    let send_close = false;

    try {
        const url = `${ExternalConfiguration.Analytics.custom.endpointBasePath}/api-realtime-live-ingestion`;
        const method = 'POST';
        Globals.events_queue.forEach( event => {
          add_to_local_storage_counter(`CustomAnalytics::send_events_inmediate-${event.event}`);
          if( event.event === Constants.Events.close) {
            send_close = true;
          }
        });
        const body = JSON.stringify( Globals.events_queue);
        if( send_close) {
          add_to_local_storage_counter(`CustomAnalytics::send_events_inmediate-JSON(close)`);
        }
        Globals.events_queue = [];
        await fetch( url, { url, method, body, keepalive: true });
        if( send_close) {
          add_to_local_storage_counter(`CustomAnalytics::send_events_inmediate-send_close`);
        }
    } catch( error) {
        console.error( new Date(), `ERROR ${LogFunctionString} - error: ${error} - JSON.stringify(error): ${JSON.stringify(error)}`);
        // TODO REVIEW gestionar de alguna forma para que los eventos no se pierdan ?? 
    }    
  },

  queue_event: (event, analyticsConfiguration) => {
    const LogFunctionString = `${LogFileString}::queue_event`;
    add_to_local_storage_counter(`CustomAnalytics::queue_event-${event}`);

    // console.info( new Date(), `INFO ${LogFunctionString} - analyticsConfiguration: `, analyticsConfiguration);

    Globals.events_queue.push({
        session_hash: Globals.session,
        timestamp: Math.floor( Date.now() / 1000),
        event,
        platform_id: analyticsConfiguration.platform.id,
        media_id: analyticsConfiguration.media.id,
        content_duration_seconds: analyticsConfiguration.media.duration,
        iframe_id: analyticsConfiguration.iframe.id,
        played_seconds: Globals.played_seconds,
        distribution_host: Globals.distribution_host,
        protocol: Globals.protocol,
        bitrate: analyticsConfiguration.bitrate,
        referrer: analyticsConfiguration.referrer,
    });

    const timeout = setTimeout( () => {
        if( timeout === Globals.last_send_timeout) {
            CustomAnalytics.send_events_inmediate();
        }
    }, 10 * 1000);

    Globals.last_send_timeout = timeout;
  },

  onLoad: (analyticsConfiguration) => {
    CustomAnalytics.queue_event( Constants.Events.load, analyticsConfiguration);
  },

  onPlay: (analyticsConfiguration) => {
    Globals.playing = true;
    Globals.last_time_event = Date.now();
    CustomAnalytics.queue_event( Constants.Events.play, analyticsConfiguration);
  },

  add_to_played_seconds: (now = Date.now()) => {
    if( Globals.playing && Globals.last_time_event) {
        Globals.played_seconds += (now - Globals.last_time_event) / 1000;
        Globals.last_time_event = now;
    }
  },

  onTime: (analyticsConfiguration) => {
    if( Globals.playing) {
        const now = Date.now();
        CustomAnalytics.add_to_played_seconds( now);
        if( !Globals.last_time_event_sent || (now - Globals.last_time_event_sent) / 1000 > 30) {
            CustomAnalytics.queue_event( Constants.Events.time, analyticsConfiguration);
            Globals.last_time_event_sent = now;
        }
    }
  },

  onPause: (analyticsConfiguration) => {
    CustomAnalytics.add_to_played_seconds();
    CustomAnalytics.queue_event( Constants.Events.pause, analyticsConfiguration);
    Globals.playing = false;
    Globals.last_time_event = null;
  },

  onBuffer: (analyticsConfiguration) => {
    CustomAnalytics.queue_event( Constants.Events.buffering, analyticsConfiguration);
  },

  onError: (analyticsConfiguration) => {
    CustomAnalytics.queue_event( Constants.Events.error, analyticsConfiguration);
  },

  onAdImpresion: (analyticsConfiguration) => {
    // CustomAnalytics.queue_event( Constants.Events., analyticsConfiguration);
  },

  onAdSkipped: (analyticsConfiguration) => {
    // CustomAnalytics.queue_event( Constants.Events., analyticsConfiguration);
  },

  onAdClicked: (analyticsConfiguration) => {
    // CustomAnalytics.queue_event( Constants.Events., analyticsConfiguration);
  },

  onAdError: (analyticsConfiguration) => {
    // CustomAnalytics.queue_event( Constants.Events., analyticsConfiguration);
  },

  onAdPlayed: (analyticsConfiguration) => {
    // CustomAnalytics.queue_event( Constants.Events., analyticsConfiguration);
  },

  onUnload: (analyticsConfiguration) => {
    add_to_local_storage_counter('CustomAnalytics::onUnload');
    CustomAnalytics.queue_event( Constants.Events.close, analyticsConfiguration);
    CustomAnalytics.send_events_inmediate();
  },

};

export default CustomAnalytics;
